// Environment variables service for client
// This file provides access to server-side environment variables by requesting them from the server

// Cache for environment variables
let envCache: Record<string, string | undefined> = {};

// Load environment variables from server
async function loadEnvironmentVariables(): Promise<Record<string, string>> {
  try {
    const response = await fetch('/api/env');
    if (!response.ok) {
      throw new Error('Failed to load environment variables');
    }
    return await response.json();
  } catch (error) {
    console.error('Error loading environment variables:', error);
    return {};
  }
}

// Get a specific environment variable
export async function getEnvVar(name: string): Promise<string | undefined> {
  if (envCache[name] !== undefined) {
    return envCache[name];
  }
  
  try {
    const env = await loadEnvironmentVariables();
    envCache = env;
    return env[name];
  } catch (error) {
    console.error(`Error getting environment variable ${name}:`, error);
    return undefined;
  }
}

// Pre-defined environment variables
export const S3_URL_PREFIX = {
  get: async () => await getEnvVar('AWS_S3_URL_PREFIX') || ''
};